import deepmerge from 'deepmerge';
import defaultTheme from './defaultTheme';

const overwriteMerge = (_destinationArray, sourceArray) => sourceArray;

export default function createHoiPoiTheme(theme = {}) {
    return deepmerge(defaultTheme, theme, { arrayMerge: overwriteMerge });
}
